import { Outlet, Navigate } from 'react-router-dom';
import { useAppDispatch } from '../../hooks/useAppDispatch';
import Layout from '../../pages/layouts/layout';
import useAuth from '../../hooks/useAuth';
import { ApplicationRole } from '../../models/authentication/application-roles';

export const HomeRoute = () => {
    const dispatch = useAppDispatch();
    const { initialized, loading, authenticated, role } = useAuth();

    if (!initialized || loading) {
        return <div>Loading...</div>;
    }

    if (!authenticated) {
        return <Navigate to="/login" replace />;
    }

    if (role == ApplicationRole.SupplierManager) {
        return <Navigate to="/admin" replace />;
    }

    if (role === ApplicationRole.OrderApprover) {
        return <Navigate to="/admin/approvals" replace />;
    }


    return (
        <Layout>
            <Outlet />
        </Layout>
    )
};